import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/additionalCarRentOptions', request)
}

export {get}
